import React, { useState } from 'react';
import Style from './media.tailwind';
import { useTranslate } from 'app/translations';
import { Icon, cn } from 'components/lib';

/**
 * @param compact  Small square thumbs for the always-visible context band,
 *                 rather than the wide 4:3 cards.
 * @param grid  Square thumbs in a fluid grid, for the rail's attachments card.
 * @param hideTitle  The parent supplies its own heading.
 */
const TicketAttachment = ({ medias, compact, grid, hideTitle }) => {
    const { _t } = useTranslate();

    if (!medias?.length) return null;

    return (
        <div>
            {!hideTitle && (
                <h3 className={Style.title}>
                    <Icon image="image" size={16} color="currentColor" className="text-text-muted" />
                    {_t('ticket.history.media')}
                </h3>
            )}
            <div
                className={cn(
                    Style.container,
                    compact && Style.containerCompact,
                    grid && Style.containerGrid,
                )}>
                {medias.map((media, index) => (
                    <MediaThumb key={media.id || index} media={media} compact={compact} grid={grid} />
                ))}
            </div>
        </div>
    );
};

function MediaThumb({ media, compact, grid }) {
    const [failed, setFailed] = useState(false);
    const filePath = media?.file_path
        ? media.file_path.startsWith('https://') || media.file_path.startsWith('http://')
            ? media.file_path
            : 'https://' + media.file_path
        : '';
    const label = media.image?.original_name || media.file_path?.split('/').pop() || 'image';

    if (!filePath || failed) {
        return (
            <div
                className={cn(Style.fallback, compact && Style.fallbackCompact, grid && Style.fallbackGrid)}
                title={compact || grid ? label : undefined}>
                <Icon
                    image="image"
                    size={compact || grid ? 18 : 32}
                    color="currentColor"
                    className="text-text-muted"
                />
                {!compact && !grid && (
                    <span className="line-clamp-2 text-xs text-text-secondary" title={label}>
                        {label}
                    </span>
                )}
            </div>
        );
    }

    return (
        <a
            target="_blank"
            rel="noreferrer"
            href={filePath}
            className={cn(Style.link, compact && Style.linkCompact, grid && Style.linkGrid)}
            title={label}>
            <img
                className={cn(Style.img, (compact || grid) && Style.imgCompact)}
                src={filePath}
                alt={label}
                loading="lazy"
                onError={() => setFailed(true)}
            />
            <div className={Style.overlay}>
                <Icon image="eye" color="white" size={compact ? 14 : 18} />
            </div>
        </a>
    );
}

export default TicketAttachment;
